import View from './view';
import React, {useCallback, useState} from 'react';
import {Props} from './model';
import {AcceptorBranchResponsePayload} from '../../../../shared/models/api';

export const AcceptorGeoMap = (props: Props) => {
  const [activeAcceptorBranch, setActiveAcceptorBranch] = useState<AcceptorBranchResponsePayload | null>(null);
  const onClickAcceptorBranch = useCallback(
    (val: AcceptorBranchResponsePayload | null) => {
      setActiveAcceptorBranch(val);
    },
    [setActiveAcceptorBranch],
  );
  const viewProps = {
    ...props,
    activeAcceptorBranch,
    onClickAcceptorBranch,
  };
  return <View {...viewProps} />;
};
